//webkitURL is deprecated but nevertheless
const URL = window.URL || window.webkitURL;
(function () {
  const recordControlsContainer = document.getElementById("controls");
  if (recordControlsContainer === null) {
    return;
  }

  var gumStream; //stream from getUserMedia()
  var rec; //Recorder.js object
  var input; //MediaStreamAudioSourceNode we'll be recording

  // shim for AudioContext when it's not avb.
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  var audioContext; //audio context to help us record

  const recordButton = document.getElementById("recordButton");
  const stopButton = document.getElementById("stopButton");
  const pauseButton = document.getElementById("pauseButton");
  
  const navigator = window.navigator;

  const transcriptInput = document.querySelector('input[name="transcript"]');
  const speechRecognitionClass = window.speechRecognition || window.webkitSpeechRecognition;
  let speechRecognition;

  if (!speechRecognitionClass)
    recordControlsContainer.innerHTML += '<div class="small my-4 card p-2 border">The browser you are using does not support speech recognition.<br/>You can still make the recording assignment, but we will not be able to automatically correct your answer.<br/>Please switch to a different browser if you want to make use of this feature.</div>';

  //add events to those 2 buttons
  recordButton.addEventListener("click", startRecording);
  stopButton.addEventListener("click", stopRecording);
  // pauseButton.addEventListener("click", pauseRecording);

  async function startRecording(e) {
    e.preventDefault();

    /*
            Simple constraints object, for more advanced audio features see
            https://addpipe.com/blog/audio-constraints-getusermedia/
        */

    var constraints = { audio: true, video: false };

    /*
            Disable the record button until we get a success or fail from getUserMedia() 
        */

    recordButton.disabled = true;
    stopButton.disabled = false;
    // pauseButton.disabled = false;

    /*
            We're using the standard promise based getUserMedia() 
            https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
        */
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      /*
                create an audio context after getUserMedia is called
                sampleRate might change after getUserMedia is called, like it does on macOS when recording through AirPods
                the sampleRate defaults to the one set in your OS for your playback device

            */
      audioContext = new AudioContext({ sampleRate: 22000 });

      /*  assign to gumStream for later use  */
      gumStream = stream;

      /* use the stream */
      input = audioContext.createMediaStreamSource(stream);

      /* 
                Create the Recorder object and configure to record mono sound (1 channel)
                Recording 2 channels  will double the file size
            */
      rec = new Recorder(input, { numChannels: 1 });

      if (!rec) return

      if (speechRecognitionClass) {
        speechRecognition = new speechRecognitionClass;
        speechRecognition.continuous = true;
        speechRecognition.lang = "nl-NL";
        speechRecognition.maxAlternatives = 1;

        speechRecognition.onresult = (event) => {
          transcriptInput.value = '';
          for (let i = 0; i < event.results.length; i++) {
            transcriptInput.value += event.results[i][0].transcript;
          }
          console.log(transcriptInput.value);
        }

        speechRecognition.onnomatch = (event) => {
          console.log('onnomatch: ', event)
        }

        speechRecognition.onerror = (event) => {
          console.log('onerror: ', event)
        }

        transcriptInput.value = '';
        speechRecognition.start();
      }

      //start the recording process
      rec.record();
    } catch (err) {
      //enable the record button if getUserMedia() fails
      recordButton.disabled = false;
      stopButton.disabled = true;
      // pauseButton.disabled = true;
    }
  }

  function pauseRecording(e) {
    e.preventDefault();
    if (!rec) return
    if (rec.recording) {
      //pause
      rec.stop();
      // pauseButton.innerHTML = '<i class="fa fa-play"></i>';
      if (speechRecognition) {
        speechRecognition.stop();
      }
    } else {
      //resume
      rec.record();
      // pauseButton.innerHTML = '<i class="fa fa-pause"></i>';
      if (speechRecognition) {
        speechRecognition.start();
      }
    }
  }

  function stopRecording(e) {
    e.preventDefault();

    //disable the stop button, enable the record too allow for new recordings
    stopButton.disabled = true;
    recordButton.disabled = false;
    // pauseButton.disabled = true;
    // pauseButton.innerHTML = '<i class="fa fa-pause"></i>';

    if (speechRecognition) {
      speechRecognition.stop();
    }

    if (!rec) return

    //tell the recorder to stop the recording
    rec.stop();

    //stop microphone access
    gumStream.getAudioTracks()[0].stop();

    //create the wav blob and pass it on to createDownloadLink
    rec.exportWAV(createLi);
  }

  function storeLocally(blob) {
    const recordingsRaw =
      localStorage.getItem(
        "question_recordings_" + recordControlsContainer.dataset.questionId
      ) || "[]";
    const recordings = JSON.parse(recordingsRaw);

    var reader = new FileReader();
    reader.onload = function (e) {
      var myDataUrl = e.target.result;
      // do something with the URL in the DOM,
      // then save it to local storage
      // console.log(myDataUrl);
    };
    reader.readAsDataURL(blob);
  }

  function createLi(blob) {
    var url = URL.createObjectURL(blob);
    var au = document.createElement("audio");
    var li = document.createElement("li");
    li.classList.add("clearfix");

    //add controls to the <audio> element
    au.controls = true;
    au.src = url;

    //add the new audio element to li
    li.appendChild(au);

    //upload link
    var answerButtonContentDiv = document.getElementById(
      "js-recordings-submit-button-content"
    );
    var upload = document.createElement("a");
    upload.href = "#";
    upload.innerHTML = answerButtonContentDiv
      ? answerButtonContentDiv.innerHTML
      : '<i class="fa fa-upload mr-3" aria-hidden="true"></i>Answer question';
    upload.classList.add("btn", "btn-primary", "float-right");
    upload.addEventListener("click", function (event) {
      event.preventDefault();
      var xhr = new XMLHttpRequest();
      xhr.onload = function (e) {
        window.location.href = xhr.responseURL + "#audio-explanation-box";
        // window.location.reload();
      };
      var fd = new FormData(document.querySelector('form'));
      //name of .wav file to use during upload and download (without extendion)
      var filename = new Date().toISOString();
      fd.append("audio_data", blob, filename);
      xhr.open("POST", window.location.href, true);
      xhr.send(fd);
    });
    li.appendChild(upload); //add the upload link to li

    var deleteButtonContentDiv = document.getElementById(
      "js-recordings-delete-button-content"
    );
    var remove = document.createElement("a");
    remove.href = "#";
    remove.innerHTML = deleteButtonContentDiv
      ? deleteButtonContentDiv.innerHTML
      : '<i class="fa fa-trash mr-3" aria-hidden="true"></i>Delete';
    remove.classList.add("btn", "btn-danger", "float-right", "mr-3");
    remove.addEventListener("click", function (event) {
      li.innerHTML = "";
    });
    li.appendChild(remove); //add the upload link to li

    //add the li element to the ol
    recordingsList.appendChild(li);
  }
})();
